/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

export const rect = (x, y, w, h) => {
    return {
        x,
        y,
        w,
        h,
        center: point(x + (w/2), y + (h/2)),
        max: point(x + w, y + h)
    }
}

export const rectCenter = aRect => {
    return point(aRect.x + (aRect.w/2), aRect.y + (aRect.h/2))
}

export const point = (x, y) => {
    return {
        x,
        y
    }
}

export const size = (w, h) => {
    return {
        w,
        h 
    }
}

export const rectsEqual = (a, b) => {
    let val = true
    val = val && a.x === b.x
    if (!val) { console.log('rectsEqual x diff', a.x, b.x) }
    val = val && a.y === b.y
    if (!val) { console.log('rectsEqual y diff', a.y, b.y) }
    val = val && a.w === b.w
    if (!val) { console.log('rectsEqual w diff', a.w, b.w) }
    val = val && a.h === b.h
    if (!val) { console.log('rectsEqual h diff', a.h, b.h) }
    return val
}

export const sizesEqual = (a, b) => {
    let val = true
    val = val && a.w === b.w
    val = val && a.h === b.h
    return val
}

export const pointsEqual = (a, b) => {
    let val = true
    val = val && a.x === b.x
    val = val && a.y === b.y
    return val
}
